import { ExternalLink } from "lucide-react";

const BISN_LOGO = process.env.REACT_APP_BISN_LOGO_URL;
const SCAO_LOGO = process.env.REACT_APP_SCAO_LOGO_URL;

export default function Footer() {
  return (
    <footer className="bg-white border-t border-[#E6E2D6] py-6">
      <div className="max-w-6xl mx-auto px-6">
        {/* Compact Layout */}
        <div className="flex flex-col items-center gap-4">
          {/* Logos Row */}
          <div className="flex items-center justify-center gap-4 md:gap-6 flex-wrap">
            <img 
              src={BISN_LOGO}
              alt="BISN - Toronto Police Service"
              className="h-10 w-auto object-contain"
              data-testid="footer-bisn-logo"
            />
            <div className="hidden md:block w-px h-8 bg-[#E6E2D6]" />
            <a 
              href="https://sicklecellon.ca/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
            >
              <img 
                src={SCAO_LOGO}
                alt="Sickle Cell Association of Ontario"
                className="h-10 w-auto object-contain"
                data-testid="footer-scao-logo"
              />
            </a>
          </div>
          
          {/* Charity Info */}
          <div className="text-center">
            <p className="text-xs text-[#666055]">
              Supporting:{" "}
              <a 
                href="https://sicklecellon.ca/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#3A5F40] hover:underline"
              >
                Sickle Cell Association of Ontario
                <ExternalLink size={10} className="inline ml-1" />
              </a>
            </p>
            <p className="text-xs text-[#666055] mt-1">
              <span className="font-medium" data-testid="charity-registration">
                Charitable Registration #: 890327067 RR0001
              </span>
            </p>
            <p className="text-xs text-[#666055]/60 mt-1">
              &copy; {new Date().getFullYear()} BISN Charity Golf Classic
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
